module.exports = function() {
  return new Worker(__webpack_public_path__ + "9f465c565514c2130389.worker.js");
};